document.addEventListener("DOMContentLoaded", function () {
  // Add this [data-filter-group] to the parent container for distinguishing multiple filters in one page !
  const groups = document.querySelectorAll("[data-filter-group]");

  groups.forEach((group) => {
    const filterButtons = group.querySelectorAll("[data-filter-target]");
    const popularProductsLayout = group.querySelector(
      ".popular-products__layout"
    );

    // Add this [data-filter-item] with the category like data-filter-item="_all" to the parent children elements !
    const items = group.querySelectorAll("[data-filter-item]");

    function handleCollapsibleFilterItems(btn) {
      const target = btn.dataset.filterTarget;
      const isAll = target === "_all";
      const hasLayout = Boolean(popularProductsLayout);
      const swiper = popularProductsLayout?.swiper;

      // Remove 'active' within this group only
      filterButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      if (hasLayout) {
        popularProductsLayout.dataset.mode = isAll ? "all" : "single";
      }

      const visibleItems = [];

      // Show/hide items within this group only
      items.forEach((item) => {
        const itemFilter = item.dataset.filterItem;
        const shouldShow = isAll || itemFilter === target;

        if (shouldShow) {
          visibleItems.push(item);
        }

        item.classList.toggle("is-hidden", !shouldShow);
      });

      if (swiper) {
        swiper.slideTo(0, 0, false);
        swiper.removeAllSlides();
        swiper.appendSlide(visibleItems);
        swiper.update();
        swiper.slideTo(0, 0, false);
      }

      group.dispatchEvent(
        new CustomEvent("filter:change", {
          detail: {
            visibleItems,
          },
        })
      );
    }

    filterButtons.forEach((btn) => {
      btn.addEventListener("click", () => handleCollapsibleFilterItems(btn));
    });
  });
});
